/**
 * Base64URL helpers replacing the `base64-url` package.
 *
 * These are UTF-8 safe: `atob`/`btoa` operate on latin1, so the byte array is
 * explicitly encoded/decoded with TextEncoder/TextDecoder. This matches what
 * `base64-url` did via Node Buffers.
 */

export function decodeBase64Url(input: string): string {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

  return new TextDecoder().decode(bytes);
}

export function encodeBase64Url(input: string): string {
  const bytes = new TextEncoder().encode(input);
  const binary = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
